module.exports = __webpack_public_path__ + "static/img/wangan.58f55c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wangan.png
// module id = Yzki
// module chunks = 44